import {
  LuBox,
  LuScanLine,
  LuShieldCheck,
} from 'react-icons/lu';
import { DocumentationIcon } from '../Services/ServicesIcons';
import './style.css';

const competencies = [
  {
    id: 'cad-drawings',
    icon: DocumentationIcon,
    label: '2D CAD Drawings',
  },
  {
    id: 'bim-models',
    icon: LuBox,
    label: '3D/BIM Models',
  },
  {
    id: 'as-built',
    icon: LuScanLine,
    label: 'As-Built Documentation',
  },
  {
    id: 'quality-control',
    icon: LuShieldCheck,
    label: 'Quality Checked',
  },
];

const CompetencyStrip = () => {
  return (
    <section
      className="section competency-strip"
      aria-label="Основные компетенции"
    >
      <div className="container">
        <ul className="competency-strip__list">
          {competencies.map(({ icon: Icon, id, label }) => (
            <li className="competency-strip__item" key={id}>
              <span className="competency-strip__icon" aria-hidden="true">
                <Icon />
              </span>
              <span className="competency-strip__label">{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CompetencyStrip;
